import type { GroupCollection, GroupCollectionsClientInterface } from './groupCollectionsClient.types';
import BaseClient from '../BaseClient';
import type { QueryParams } from '~/services/api';

export default class CorporateGroupCollectionsClient extends BaseClient implements GroupCollectionsClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getGroupCollections(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/group-collections`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getGroupCollection(groupCollectionId: number) {
        const url = `/api/v3/teams/${this.teamId}/group-collections/${groupCollectionId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createGroupCollection(data: GroupCollection) {
        const url = `/api/v3/teams/${this.teamId}/group-collections`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateGroupCollection(groupCollectionId: number, data: GroupCollection) {
        const url = `/api/v3/teams/${this.teamId}/group-collections/${groupCollectionId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteGroupCollection(groupCollectionId: number) {
        const url = `/api/v3/teams/${this.teamId}/group-collections/${groupCollectionId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getGroupCollectionsGroupCounts(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/group-collections/group-counts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getGroupCollectionGroupMemberships(groupCollectionId: number) {
        const url = `/api/v3/teams/${this.teamId}/group-collections/${groupCollectionId}/group-memberships`;
        return this.makeCoreApiRequest(url, 'get');
    }
}
